import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import Window from "../2/Controls/Window";
import AddEditExpenseCategory from "../Settings/AddEditExpenseCategory";

class ExpenseCategoryList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            list: [],
            totalCount: 0,
            loading: false,

            page: 1,
            pageSize: 25,
            showDelete: false,
            showAddExpenseCategory: false,

            selectedRow: null,

            listPageSettings: {

                Title: "Expense Category",

                Search: {
                    showSearch: false
                },

                HeaderButtons: [
                    {
                        ButtonType: "Button",
                        Type: "primary",
                        Text: "New",
                        Icon: "add",
                        Action: "new"
                    },
                ],

                Columns: [
                    {
                        Name: "Expense Category",
                        Type: "field",
                        Columns: [{ Column: "ExpenseCategory" }],
                    },
                    {
                        Name: "Expense Category",
                        Type: "field",
                        ShowInMobile: true,
                        Columns: [{ Column: "ExpenseCategory" }],
                    },
                ],

                RowButtons: [
                    {
                        ButtonType: "ImageButton",
                        Type: "edit",
                        Text: "Edit",
                        Icon: "edit"
                    },
                    {
                        ButtonType: "ImageButton",
                        Type: "delete",
                        Text: "Delete",
                        Icon: "delete"
                    }
                ]
            }
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {

        this.setState({ loading: true });

        try {

            let categories = await this.props.getExpenseCategories(this.props.user.store.key);

            this.setState({
                list: categories,
                totalCount: categories.length,
                loading: false,
                page: 1
            });

        }
        catch (error) {

            console.error(error);

            this.setState({
                loading: false
            });

        }

    };

    // =====================
    // PAGINATION
    // =====================

    onNextClick = () => {

        const totalPages = Math.ceil(
            this.state.totalCount / this.state.pageSize
        );

        if (this.state.page < totalPages) {

            this.setState({
                page: this.state.page + 1
            });

        }

    };

    onPreviousClick = () => {

        if (this.state.page > 1) {

            this.setState({
                page: this.state.page - 1
            });

        }

    };

    onFirstClick = () => {

        this.setState({
            page: 1
        });

    };

    onLastClick = () => {

        const totalPages = Math.ceil(
            this.state.totalCount / this.state.pageSize
        );

        this.setState({
            page: totalPages
        });

    };

    onRecordsPerPageCountChange = (size) => {

        this.setState({
            pageSize: Number(size),
            page: 1
        });

    };

    // =====================
    // HEADER BUTTON
    // =====================

    onHeaderButtonClicked = (btn) => {

        if (btn.Action === "new") {

            this.setState({
                showAddExpenseCategory: true,
                selectedRow: null
            });

        }

    };

    // =====================
    // ROW BUTTONS
    // =====================

    onRowButtonClicked = (btn, row) => {

        if (btn.Type === "edit") {

            this.setState({
                showAddExpenseCategory: true,
                selectedRow: row
            });

        }

        if (btn.Type === "delete") {

            this.setState({
                showDelete: true,
                selectedRow: row
            });

        }

    };

    // =====================
    // DELETE
    // =====================

    deleteRecord = async () => {

        this.setState({
            showDelete: false,
            loading: true
        });

        await this.props.deleteExpenseCategories(
            this.state.selectedRow.key
        );

        this.setState({
            loading: false,
            selectedRow: null
        });

        this.loadData();

    };

    // =====================
    // POPUP EVENTS
    // =====================

    onPostPopupSave = () => {

        this.setState(
            {
                showAddExpenseCategory: false,
                selectedRow: null
            },
            this.loadData
        );

    };

    onClosePopup = () => {

        this.setState({
            showAddExpenseCategory: false,
            selectedRow: null
        });

    };

    onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};
    render() {

        return (

            <>

                <ListingPage

                    {...this.props}
                     onPageChange={this.onPageChange}

                    listPageSettings={{
                        ...this.state.listPageSettings,
                    }}

                    list={
                        this.state.list.slice(
                            (this.state.page - 1) * this.state.pageSize,
                            this.state.page * this.state.pageSize
                        )
                    }

                    loading={this.state.loading}

                    totalItemsCount={this.state.totalCount}

                    recordFrom={
                        (this.state.page - 1) * this.state.pageSize
                    }

                    itemsCountPerPage={this.state.pageSize}

                    onNextClick={this.onNextClick}

                    onPreviousClick={this.onPreviousClick}

                    onFirstClick={this.onFirstClick}

                    onLastClick={this.onLastClick}

                    onRecordsPerPageCountChange={
                        this.onRecordsPerPageCountChange
                    }

                    onHeaderButtonClicked={
                        this.onHeaderButtonClicked
                    }

                    onRowButtonClicked={
                        this.onRowButtonClicked
                    }

                />

                {this.state.showDelete && (

                    <Window

                        header="Delete"

                        modal

                        onClose={() =>
                            this.setState({
                                showDelete: false
                            })
                        }

                        onButtonClick={(btn) => {

                            if (btn === "Yes")
                                this.deleteRecord();

                            else
                                this.setState({
                                    showDelete: false
                                });

                        }}

                        buttons={[
                            {
                                Type: "secondary",
                                Text: "No",
                                Align: "left"
                            },
                            {
                                Type: "primary",
                                Text: "Yes",
                                Align: "right"
                            }
                        ]}

                    >

                        Are you sure you want to delete?

                    </Window>

                )}

                {this.state.showAddExpenseCategory && (

                    <AddEditExpenseCategory

                        {...this.props}

                        expenseCategory={this.state.selectedRow}

                        onSave={this.onPostPopupSave}

                        onClose={this.onClosePopup}

                    />

                )}

            </>

        );

    }

}

export default ExpenseCategoryList;